import cx from "classnames";
import { BlogPaginationArrow } from "components/icons/BlogPaginationArrow";
import Link from "next/link";
import { useRouter } from "next/router";
import { FC } from "react";
import st from "./ArticlesPageNavigation.module.scss";

type ArticlesPageNavigationProps = {
  totalPages: number;
  baseUrl: string;
};

export const ArticlesPageNavigation: FC<ArticlesPageNavigationProps> = ({
  totalPages,
  baseUrl,
}) => {
  const { query } = useRouter();
  const currentPage = query?.page ? parseInt(query.page as string) : 1;

  const pages = [...Array(totalPages).keys()];
  const isPreviousPageDisabled = currentPage === 1;
  const isNextPageDisabled = currentPage === totalPages;

  return (
    <div className={st.pagesNavigationContainer}>
      <Link
        href={
          currentPage === 2 ? baseUrl : `${baseUrl}?page=${currentPage - 1}`
        }
        className={cx(isPreviousPageDisabled && st.disabledPageButton)}
        tabIndex={isPreviousPageDisabled ? -1 : undefined}
      >
        <BlogPaginationArrow />
      </Link>
      {pages.map((page) => {
        if (page === 0) {
          return (
            <Link
              href={baseUrl}
              className={cx(
                st.pagesNavigationButton,
                currentPage === 1 && st.selectedPageButtton,
              )}
              key={page}
            >
              {page + 1}
            </Link>
          );
        } else {
          return (
            <Link
              href={`${baseUrl}?page=${page + 1}`}
              className={cx(
                st.pagesNavigationButton,
                currentPage === page + 1 && st.selectedPageButtton,
              )}
              key={page}
            >
              {page + 1}
            </Link>
          );
        }
      })}
      <Link
        href={`${baseUrl}?page=${currentPage + 1}`}
        className={cx(
          st.nextPageButton,
          isNextPageDisabled && st.disabledPageButton,
        )}
      >
        <BlogPaginationArrow />
      </Link>
    </div>
  );
};
